import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import injectSheet from 'react-jss';
import compose from 'recompose/compose';
import classNames from 'classnames';
import { CONTRACT_SERIES } from 'constants/index';
import { TextField, SelectField } from '@avinfors/redux-form-fields';
import { required } from 'shared/validationFields';
import Logo from 'images/logo_u.jpg';

class ResetPasswordForm extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.tempPasswordSent && !this.props.tempPasswordSent) {
      setTimeout(() => this.props.triggerPassRecoveryMode(), 3000);
    }
  }

  render() {
    const {
      handleSubmit,
      submitOnEnter,
      classes,
      error,
      triggerPassRecoveryMode,
      tempPasswordSent
    } = this.props;

    return (
      <Form onKeyDown={submitOnEnter(handleSubmit)} onSubmit={handleSubmit}>
        <Row>
          <Col
            sm={{ size: 8, order: 1 }}
            xs={{ size: 12, order: 2 }}
            className='d-flex align-items-center'
          >
            <h5 className='m-0'>Сброс пароля</h5>
          </Col>
          <Col
            className='text-left text-sm-right py-3 py-sm-0'
            sm={{ size: 4, order: 2 }}
            xs={{ size: 12, order: 1 }}
          >
            <img
              src={Logo}
              alt='Югория Жизнь'
              className='img-fluid'
              style={{ position: 'relative', top: -3, maxHeight: 60 }}
            />
          </Col>
        </Row>
        <Row form>
          <Col sm={4}>
            <FormGroup>
              <Label>Серия договора</Label>
              <div className='SelectFieldLg'>
                <Field
                  component={SelectField}
                  name='seria'
                  placeholder=''
                  validate={required.req}
                  options={CONTRACT_SERIES.map((s, i) => ({ code: i, name: s }))}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={8}>
            <FormGroup>
              <Label>Номер договора</Label>
              <Field component={TextField} name='number' validate={required.req} bsSize='lg' />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <div className='text-right'>
            <Button
              className={classNames(classes.recoverLink, 'text-right p-0')}
              color='link'
              onClick={triggerPassRecoveryMode}
            >
              Назад
            </Button>
          </div>
          <div className='text-danger'>
            {error.split('\n').map((item, i) => {
              return <div key={i}>{item}</div>;
            })}
          </div>
          {tempPasswordSent && (
            <div className='text-success'>Новый пароль был отправлен смс-сообщением.</div>
          )}
        </FormGroup>

        <Button color='success' onClick={handleSubmit} size='lg' block>
          Отправить пароль по СМС
        </Button>
      </Form>
    );
  }
}

ResetPasswordForm.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitOnEnter: PropTypes.func.isRequired,
  triggerPassRecoveryMode: PropTypes.func.isRequired,
  error: PropTypes.string,
  tempPasswordSent: PropTypes.bool.isRequired
};

ResetPasswordForm.defaultProps = {
  error: ''
};

const styles = theme => ({
  recoverLink: {
    color: '#8695a8',
    '&:hover': {
      color: '#3069B2'
    },
    cursor: 'pointer',
    textAlign: 'right'
  }
});

export default compose(
  reduxForm({ form: 'resetPasswordForm' }),
  injectSheet(styles)
)(ResetPasswordForm);
